// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../shared/material.module';
import { SharedModule } from '../shared/shared.module';
import { DealerDashboardComponent } from './dealer-dashboard/dealer-dashboard.component';
import { DealerTenantHeaderComponent } from './dealer-tenant-header/dealer-tenant-header.component';
import { DealerUserHeaderComponent } from './dealer-user-header/dealer-user-header.component';
import { DealerSideNavComponent } from './dealer-side-nav/dealer-side-nav.component';
import { DealerModule } from '../dealer/dealer.module';

@NgModule({
    declarations: [DealerDashboardComponent, DealerSideNavComponent, DealerTenantHeaderComponent, DealerUserHeaderComponent],
    imports: [CommonModule, DealerModule, MaterialModule, RouterModule, SharedModule],
})
export class DealerDashboardModule {}
